var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 10.5273 9.96582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 9.96582,
    opacity: 0,
    width: 10.5273,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 4.98047C9.96094 7.72461 7.72949 9.96094 4.98047 9.96094C2.23633 9.96094 0 7.72461 0 4.98047C0 2.23145 2.23633 0 4.98047 0C7.72949 0 9.96094 2.23145 9.96094 4.98047ZM2.34375 4.4043C2.34375 5.55176 3.28613 6.49902 4.43848 6.49902C4.84375 6.49902 5.22461 6.37207 5.54688 6.17188L6.83594 7.45605C6.93848 7.56348 7.0459 7.6123 7.19238 7.6123C7.43652 7.6123 7.60254 7.43164 7.60254 7.17773C7.60254 7.06543 7.54883 6.95801 7.46582 6.87012L6.17188 5.56641C6.39648 5.23926 6.5332 4.83398 6.5332 4.4043C6.5332 3.24707 5.59082 2.30469 4.43848 2.30469C3.28613 2.30469 2.34375 3.25195 2.34375 4.4043ZM5.83984 4.4043C5.83984 5.1709 5.20508 5.81055 4.43848 5.81055C3.66699 5.81055 3.03223 5.1709 3.03223 4.4043C3.03223 3.63281 3.66699 2.99316 4.43848 2.99316C5.20508 2.99316 5.83984 3.62793 5.83984 4.4043Z",
    fill: "#d1d5db"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dbcf5ccf8d6619c1eada3af083187a40.svg";
export { ForwardRef as ReactComponent };